import axios from 'axios';
import { TriggersApiResponse, Trigger, TriggerDetailApiResponse } from '../interfaces';

export const fetchTriggersData = async (page: number = 1): Promise<TriggersApiResponse> => {
  
  const response = await axios.get<TriggersApiResponse>('https://api.diwo.capital/v1/triggers', {
    params: {
      page: page
    }
  });

  return {
    data: response.data.data,
    total: response.data.total,
    timestamp: response.data.timestamp
  };
};

export const fetchTriggerDetail = async (id: number): Promise<Trigger> => {
  const response = await axios.get<TriggerDetailApiResponse>(`https://api.diwo.capital/v1/triggers/${id}`);
  return response.data.data;
}; 